export default "__VITE_ASSET__edd0d75d__"